import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const AutocompleteForm = ({
  control,
  name,
  label,
  onChange,
  defaultValue,
  rules,
  error,
  options,
  optionSelected,
  variant = "outlined",
  value,
}) => {
  const classesTablero = useStylesTablero();
  if (control)
    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue || null}
        render={(props) => (
          <Autocomplete
            onChange={(event, item) => {
              props.onChange(item);
              if (onChange) onChange(item);
            }}
            size="small"
            fullWidth
            noOptionsText="No hay coincidencias"
            options={options}
            defaultValue={defaultValue || null}
            getOptionLabel={(item) => item[optionSelected.label]}
            getOptionSelected={(option, value) =>
              value == undefined ||
              value === "" ||
              option[optionSelected.id] === value[optionSelected.id]
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={Boolean(error)}
                helperText={error}
                variant={variant}
                className={classesTablero.field}
              />
            )}
          />
        )}
      />
    );
  return (
    <Autocomplete
      onChange={(event, item) => {
        if (onChange) onChange(item);
      }}
      size="small"
      fullWidth
      value={value}
      noOptionsText="No hay coincidencias"
      options={options}
      defaultValue={defaultValue || null}
      getOptionLabel={(item) => item[optionSelected.label]}
      getOptionSelected={(option, value) =>
        value == undefined ||
        value === "" ||
        option[optionSelected.id] === value[optionSelected.id]
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={Boolean(error)}
          helperText={error}
          variant={variant}
          className={classesTablero.field}
        />
      )}
    />
  );
};
AutocompleteForm.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.object,
  rules: PropTypes.object.isRequired,
  error: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  optionSelected: PropTypes.shape({
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }),
};

AutocompleteForm.defaultProps = {
  label: "",
  defaultValue: null,
  optionSelected: { id: "default", label: "default" },
};

export default AutocompleteForm;
